<!-- 年会游查询 -->
<template>
    <div class='AnnualTripQuery'>
        <app-breadcrumb />
        <el-table v-loading="doLoading" :data="list" border fit size="mini" stripe style="width: 100%">
            <el-table-column :label="$t('pdWarehouseStock.companyNo')" prop="companyCode" align="center" />
            <el-table-column :label="$t('miMember.memberNo')" prop="memberNo" align="center" />
            <el-table-column :label="$t('person.name')" prop="memberName" align="center" />
            <el-table-column :label="$t('mi.honourLevel')" prop="levelType" align="center">
                <template v-slot="{ row }">
                    {{ $lt(initDict.mimemberhonourLevel, row.cardType) }}
                </template>
            </el-table-column>
            <el-table-column :label="$t('commond.levelType')" prop="levelType" align="center">
                <template v-slot="{ row }">
                    {{ $lt(initDict.mimemberlevel, row.levelType) }}
                </template>
            </el-table-column>
            <el-table-column :label="$t('Phase.1.Community.SmallPerformance')" prop="smallPartSell" align="center" />
            <el-table-column :label="$t('mi.joindate')" prop="registerDate" align="center" />
            <el-table-column :label="$t('Update.Time')" prop="createTime" align="center" />
        </el-table>
    </div>
</template>

<script>
import { mapGetters } from "vuex";
import { pageByDTO } from "@/api/rpt/view.js";

export default {
    name: 'AnnualTripQuery',
    components: {},
    data() {
        return {
            viewNameList: [
                {
                    companyCode: 'CI',
                    viewName: 'rpt_20260112003',
                    label: '科特中国游'
                },
                {
                    companyCode: 'CM',
                    viewName: 'rpt_20260112001',
                    label: '喀麦隆年会游'
                },
                {
                    companyCode: 'NG',
                    viewName: 'rpt_20260105001',
                    label: '尼日利亚年会游'
                },
                {
                    companyCode: 'ZA',
                    viewName: 'rpt_20260112002',
                    label: '南非中国游'
                }
            ],
            list: [],
            doLoading: false,
            initDict: {
                status: 'fi_ac_appl_status_cn',
                mimemberhonourLevel: 'cn.mimember.cardtype',    //荣衔
                mimemberlevel: 'cn.member.level'    //级别
            }
        };
    },
    computed: {
        ...mapGetters([
            'companyCode',
            'isAgent'
        ]),
    },
    async created() {
        let viewName = ''
        const viewNameObj = this.viewNameList.find(item => item.companyCode === this.companyCode);
        if (viewNameObj) {
            viewName = viewNameObj.viewName;
        }
        if (!viewName) {
            this.$message.error('viewName is null');
            return;
        }
        this.doLoading = true;
        try {
            const res = await pageByDTO({ viewName });
            this.list = res.data.records;
            this.total = res.data.total;
        } catch (error) {
            this.$message.error(error);
        } finally {
            this.doLoading = false;
        }
    },
}
</script>
<style scoped></style>